import { Component, Inject, OnInit } from '@angular/core';
import { L10N_LOCALE, L10nLocale, L10nTranslationModule } from 'angular-l10n';
import { MessagesModule } from 'primeng/messages';

@Component({
  selector: 'supplierDB-registration-thank-you-page',
  standalone: true,
  imports: [L10nTranslationModule, MessagesModule],

  templateUrl: './thank-you-page.component.html',
  styleUrl: './thank-you-page.component.scss',
})
export class ThankYouPageComponent implements OnInit {
  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}

  ngOnInit(): void {
    localStorage.removeItem("registration-token");
  }
}
